import React from 'react';
import { ConsentDecorator } from '../../components/RoutesDecorator/ConsentDecorator';
import { TimeSyncDecorator } from '../../components/RoutesDecorator/TimeSyncDecorator';
import { ExternalSystemAuthorizationHandler } from '../../containers';

/**
 * Страница перехода во внешние системы
 */
const ExternalSystemAuthorizationHandlerPage: React.FC = () => {
    
    // отдаем все вложенные роуты
    return  (
        <ConsentDecorator>
            <TimeSyncDecorator>
                <ExternalSystemAuthorizationHandler />
            </TimeSyncDecorator>
        </ConsentDecorator>
    );
};

/**
 * Название компонента, используемое при отладке.
 */
ExternalSystemAuthorizationHandlerPage.displayName = 'ExternalSystemAuthorizationHandlerPage';

export default ExternalSystemAuthorizationHandlerPage;
